import { ServiceUsagesSourceEnum } from '@e-socna/data-layer';
import type { QuotationWorkflowId } from '@e-socna/data-layer';

interface QuotationInfoShape {
  readonly workflowId: string;
  readonly stateId: string;
}

type QuotationWorkflowsIdMapShape = Readonly<
  Record<
    string,
    | Readonly<{
        stateMachine: readonly Readonly<{
          stateId: string;
          settings: Readonly<{
            serviceUsagesSource: ServiceUsagesSourceEnum;
          }>;
        }>[];
      }>
    | undefined
  >
>;

// Single source of truth for the live-vs-frozen-snapshot selection rule,
// shared by every reader of a Mission's quotation data (was duplicated
// between useServiceUsagesConsolidationAndCalculation and
// useFullyConsolidatedServiceUsages).
export function resolveServiceUsagesSource({
  quotationInfo,
  quotationWorkflowsIdMap,
}: Readonly<{
  quotationInfo: QuotationInfoShape | null | undefined;
  quotationWorkflowsIdMap: QuotationWorkflowsIdMapShape;
}>): ServiceUsagesSourceEnum {
  const isServicesInfoSource =
    !quotationInfo ||
    quotationWorkflowsIdMap[
      quotationInfo.workflowId as QuotationWorkflowId
    ]?.stateMachine.find((node) => node.stateId === quotationInfo.stateId)
      ?.settings.serviceUsagesSource === ServiceUsagesSourceEnum.ServicesInfo;

  return isServicesInfoSource
    ? ServiceUsagesSourceEnum.ServicesInfo
    : ServiceUsagesSourceEnum.QuotationInfo;
}
